import { useEffect, useState } from 'react';
import { Result, Spin } from 'antd';
import { consumeDelegatedEntry } from './delegated-entry-flow';

export default function DelegatedEntryPage() {
  const [error, setError] = useState<string | null>(null);
  useEffect(() => { void consumeDelegatedEntry().catch(() => setError('票据无效或已过期，请返回总部后台重新点击“进入后台”')); }, []);
  return error
    ? <Result status="error" title="进入企业后台失败" subTitle={error} />
    : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" /></div>;
}
